import useScript from "../../hooks/useScript";

export const AutofirmaScripts = () => {
    useScript('/assets/js/autoscript.js');
    useScript('/assets/js/forge.min.js');

    return <></>;
}